module.exports = __webpack_public_path__ + "img/crypto_masters_logo_404.30f93ad1.svg";